import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: './client-services-dialog',
  templateUrl: './client-services-dialog.html',
  styleUrls: ['./client-services-dialog.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ClientServicesDialog {
  blockContent = null;
  title = '';
  contentHeader = '';
  content = '';

  generateLink(moreInfoLink: string = null, moreInfoText: string) {
    return `${
      moreInfoLink
        ? `<a href="${moreInfoLink}" target="_blank" rel="noopener noreferrer">${moreInfoText}</a>`
        : ''
    }`;
  }

  generateETAContent(
    municipalName: string,
    startDate: number = 6,
    endDate: number = 6,
    moreInfoLink: string = null,
    moreInfoText: string
  ) {
    if (municipalName) {
      this.blockContent = `The Township of ${municipalName} services are scheduled for pickup:
                             <ul class="list">
                               <li>Start time: ${startDate} am</li>
                               <li>End time: ${endDate} pm</li>
                             </ul>`;
      this.contentHeader = `Note:`;
      this.content = `<ol class="list">
                         <li>If you're still within this service window please bear with us a little longer, as services may be slightly delayed.</li>
                         <li>If your service was not picked up during the service window, please submit a "Missed Service Request".</li>
                         <li>For more information on your waste management services, click here ${this.generateLink(
                           moreInfoLink,
                           moreInfoText
                         )}</li>
                       </ol>`;
    }
  }

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      selectedClient: {
        value: number;
        text: string;
        options: string[];
      };
      selectedOption:
        | 'Bulk Pickup'
        | 'ETA Request'
        | 'Schedule a Rear Yard Pickup';
    }
  ) {
    this.title = `${data.selectedOption} - ${data.selectedClient.text}`;
    const selectedClient = data.selectedClient;
    const selectedService = data.selectedOption;

    switch (selectedClient.value) {
      // Livingston
      case 1:
        {
          if (selectedService === 'Bulk Pickup') {
            this.blockContent = `As a Livingston resident, your Bulk days are the last service day of each month (specific to your schedule). If there is a holiday refer to the town website.`;
            this.contentHeader = `If your Bulk was not picked up as expected, please submit a Missed Service Request Note:`;
            this.content = `<ol class="list">
                           <li>RTS does not haul construction debris: for example: tiles, 2x4s, sheetrock, demo and building materials Metal</li>
                           <li>RTS does not haul metal or items containing metal - residents must contact their DPW to schedule a pickup - ex.) metal chairs, tables, white goods, scrap metal etc.</li>
                           <li>RTS does not haul - pallets, shipping crates, items exceeding 50 lbs, electronics, items with liquids inside, etc.</li>
                           <li>Glass items must be taped securely to prevent shatter in the street - use duct tape.</li>
                           <li>Tires - will be collected with bulk - no rims on tires.</li>
                           <li>Paint cans - lids must be off, not in bags, paint must be completely dried out before we can haul.</li>
                           <li>For Holiday recoveries, refer to your town website ${this.generateLink(
                             'https://www.livingstonnj.org/288/Garbage',
                             'Garbage | Livingston Township, NJ'
                           )}</li>
                         </ol>`;
          } else if (selectedService === 'ETA Request') {
            this.generateETAContent(
              selectedClient.text,
              6,
              6,
              'https://www.livingstonnj.org/288/Garbage',
              'Garbage | Livingston Township, NJ'
            );
          } else if (selectedService === 'Schedule a Rear Yard Pickup') {
            this.title = `Livingston Rear-Yard collection service`;
            this.blockContent = `<p>Click on the following link and fill out the form to sign up: <a href="https://na3.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=10772e25-2979-480a-82d4-c931dc5d3290&env=na3&acct=aa83124e-b7b8-4a0f-9604-20de2d224510&v=2" target="_blank" rel="noopener noreferrer">here</a></p>
          Please ensure you complete the request within 24 hours of opening the page for proper processing.`;
            this.contentHeader = `Note:`;
            this.content = `<ol class="list">
                           <li>The monthly fee for rear yard collection is $28.75. Only electronic auto payment methods are accepted at this time.</li>
                           <li>Please reference <a href="https://livingstonnj.org/DocumentCenter/View/6647/Garbage-Collection-Zones-Map-PDF?bidId=" target="_blank" rel="noopener noreferrer">this map</a> to locate your zone and see your home's service day.</li>
                           </ol>`;
          }
        }
        break;
      // Mendham
      case 2:
        {
          if (selectedService === 'Bulk Pickup') {
            this.blockContent = `As a Mendham resident, your Bulk days are any service day. Collection depends on the correct number of stickers on the item - refer to the town website for stickers per item.`;
            this.contentHeader = `If your Bulk was not picked up as expected, please submit a Missed Service Request Note:`;
            this.content = `<ol class="list">
                           <li>Note stickers are needed for bulk items, and stickers can be purchased at your local CVS-Mendham.</li>
                           <li>Glass items must be taped securely to prevent shatter in the street - use duct tape.</li>
                           <li>For Holiday recoveries, refer to your town website ${this.generateLink(
                             'https://www.mendhamtownship.org/department-public-works/pages/trash-recycling-faqs',
                             'Trash & Recycling FAQs | Mendham Township, NJ'
                           )}</li>
                         </ol>`;
          } else if (selectedService === 'ETA Request') {
            this.generateETAContent(
              selectedClient.text,
              6,
              6,
              'https://www.mendhamtownship.org/department-public-works/pages/trash-recycling-faqs',
              'Trash & Recycling FAQs | Mendham Township, NJ'
            );
          }
        }
        break;
      // Hawthorne
      case 3:
        {
          if (selectedService === 'Bulk Pickup') {
            this.blockContent = `As a Hawthorne resident, your Bulk Day is the 1st four collection days of the month - depending on your street (6-item limit only).`;
            this.contentHeader = `If your Bulk was not picked up as expected, please submit a Missed Service Request Note:`;
            this.content = `<ol class="list">
                           <li>Metal - RTS does not haul metal or items containing metal - ex.) metal chairs, tables, white goods, scrap metal etc.</li>
                           <li>RTS does not haul - construction debris, sheetrock, tiles, 2x4s, pallets, shipping crates, items exceeding 50 lbs. electronics, items with liquids inside, etc.</li>
                           <li>Glass items must be taped securely to prevent shatter in the street - use duct tape.</li>
                           <li>For Holiday recoveries, refer to your town website ${this.generateLink(
                             'https://www.hawthornenj.org/229/Garbage-Recycling',
                             'Garbage & Recycling | Hawthorne, NJ'
                           )}</li>
                         </ol>`;
          } else if (selectedService === 'ETA Request') {
            this.generateETAContent(
              selectedClient.text,
              7,
              7,
              'https://www.hawthornenj.org/229/Garbage-Recycling',
              'Garbage & Recycling | Hawthorne, NJ'
            );
          }
        }
        break;
      // Pennsville
      case 4:
        {
          if (selectedService === 'Bulk Pickup') {
            this.blockContent = `As a Pennsville resident, your Bulk waste is done by your Township using the sticker program (1st Tuesday of the month).`;
            this.contentHeader = `Note:`;
            this.content = `<ol class="list">
                           <li>Any questions related to what is considered "BULK" your town website has a detailed breakout of items that are considered Bulk.</li>
                           <li>For Holiday recoveries, refer to your town website ${this.generateLink(
                             'https://www.pennsville.org/about-us/community-information/trash_recycling/',
                             'Trash & Recycling'
                           )}</li>
                         </ol>`;
          } else if (selectedService === 'ETA Request') {
            this.generateETAContent(
              selectedClient.text,
              6,
              6,
              'https://www.pennsville.org/about-us/community-information/trash_recycling/',
              'Trash & Recycling'
            );
          }
        }
        break;
      // Matawan
      case 5:
        {
          if (selectedService === 'Bulk Pickup') {
            this.blockContent = `As a Matawan resident, your Bulk Day is every Monday and is limited to 2 items each collection day.`;
            this.contentHeader = `If your Bulk was not picked up as expected, please submit a Missed Service Request Note:`;
            this.content = `<ol class="list">
                           <li>RTS will collect metal items on the last T.hursday of each month residents must contact the Borough prior to that date to be placed on the metal list.</li>
                           <li>RTS does not haul - construction debris, pallets, shipping crates, items exceeding 50 lbs. electronics, items with liquids inside, etc.</li>
                           <li>Glass items must be taped securely to prevent shatter in the street - use duct tape.</li>
                           <li>Metal - must call the Borough to be placed on a white goods/metal list.</li>
                           <li>For Holiday recoveries, refer to your town website ${this.generateLink(
                             'https://www.matawanborough.com/matawan/Borough%20SERVICES/Recycling/',
                             'Borough SERVICES Recycling'
                           )}</li>
                         </ol>`;
          } else if (selectedService === 'ETA Request') {
            this.generateETAContent(
              selectedClient.text,
              6,
              6,
              'https://www.matawanborough.com/matawan/Borough%20SERVICES/Recycling/',
              'Borough SERVICES Recycling'
            );
          }
        }
        break;
      // Kingsford Heights
      case 6:
        {
          if (selectedService === 'Bulk Pickup') {
            this.blockContent = `As a Kingsford Heights resident, your Bulk waste is to be taken to the Community center at  515 Wayland Rd, Kingsford Heights, IN..`;
            this.contentHeader = `Note:`;
            this.content = `<ol class="list">
                           <li>Any questions related to what is considered "BULK" your town website has a detailed breakout of items that are considered Bulk.</li>
                           <li>For Holiday recoveries, refer to your town website ${this.generateLink(
                             'https://www.townofkingsfordheights.com',
                             'Community Center | Kingsford Heights, IN'
                           )}</li>
                         </ol>`;
          } else if (selectedService === 'ETA Request') {
            this.generateETAContent(
              selectedClient.text,
              6,
              6,
              'https://www.townofkingsfordheights.com',
              'Community Center | Kingsford Heights, IN'
            );
          }
        }
        break;
      default:
        {
          this.blockContent = '';
          this.contentHeader = '';
          this.content = '';
        }
        break;
    }
  }
}
